<div class="card-body">
  <div class="row">
    <div [class]="modal ? 'col-12' : 'col-md-8'">
      <div class="mb-4 hidden-xs account-profile-info">
        {{ 'required_fields_label' | translate }}
      </div>

      @if (updateErrorMessage) {
        <div class="mb-4">
          <app-edit-permissions-banner [bannerType]="BannerType.error">
            <div class="account-profile-error-header">
              {{ 'error_updating_profile' | translate }}
            </div>
            <p class="account-profile-error-message">
              {{ updateErrorMessage || 'error_action_cant_be_performed' | translate }}
            </p>
          </app-edit-permissions-banner>
        </div>
      }

      <form [formGroup]="form" (submit)="onSubmit()">
        <fieldset>
          <legend class="visuallyhidden">{{ 'profile_details' | translate }}</legend>

          <div class="mb-4">
            <app-avatar-input [formControlName]="FormField.AVATAR" [label]="'form_label_avatar'"></app-avatar-input>
          </div>

          <div class="mb-4">
            <ds-input
              [label]="'email' | translate"
              [instructions]="'email_will_not_be_publicly_displayed' | translate"
              [state]="DsInputStates.inactive"
              data-test-id="account-profile-email"
            >
              <input ds-input-field type="email" [formControlName]="FormField.EMAIL" />
            </ds-input>
          </div>

          <div class="mb-4">
            <ds-input
              [label]="'display_name' | translate"
              [required]="true"
              [errorState]="(displayNameError$ | async)?.length > 0"
              [errorMessage]="displayNameError$ | async"
              data-test-id="account-profile-display-name"
            >
              <input ds-input-field autocomplete="off" data-lpignore="true" [formControlName]="FormField.DISPLAY_NAME" />
            </ds-input>
          </div>

          <div class="mb-4">
            <ds-input [label]="'first_name' | translate" data-test-id="account-profile-first-name">
              <input ds-input-field autocomplete="off" data-lpignore="true" [formControlName]="FormField.FIRST_NAME" />
            </ds-input>
          </div>

          <div class="mb-4">
            <ds-input [label]="'last_name' | translate" data-test-id="account-profile-last-name">
              <input ds-input-field autocomplete="off" data-lpignore="true" [formControlName]="FormField.LAST_NAME" />
            </ds-input>
          </div>

          <div class="mb-4">
            <ds-input
              [label]="'account_profile_label_role' | translate"
              [required]="true"
              [errorState]="(userRoleError$ | async)?.length > 0"
              [errorMessage]="userRoleError$ | async"
              data-test-id="account-profile-role"
            >
              <select ds-input-field class="mw-100" [formControlName]="FormField.USER_ROLE">
                <option [ngValue]="null" selected disabled>
                  {{ 'not_specified' | translate }}
                </option>
                @for (userRole of userRoles$ | async; track userRole[$userRole._id]) {
                  <option value="{{ userRole[$userRole._id] }}">{{ userRole[$userRole.translationKey] | translate }}</option>
                }
              </select>
            </ds-input>
          </div>

          @if (modal) {
            <hr />
          }

          <div class="mb-4">
            <ds-input [label]="'form_label_timezone' | translate" data-test-id="account-profile-timezone">
              <select ds-input-field class="mw-100" [formControlName]="FormField.TIMEZONE">
                <option [ngValue]="null" selected disabled>
                  {{ 'form_label_select_time_zone' | translate }}
                </option>
                @for (timezone of timezones; track $index) {
                  <option value="{{ timezone.value }}">{{ timezone.text }}</option>
                }
              </select>
            </ds-input>
          </div>

          <div class="mb-4">
            <ds-input [label]="'form_label_language' | translate" data-test-id="account-profile-language">
              <select ds-input-field class="mw-100" [formControlName]="FormField.USER_LANGUAGE">
                @for (language of languages$ | async; track $index) {
                  <option value="{{ language.locale }}">{{ language.nativeName }} ({{ language.englishName }})</option>
                }
              </select>
            </ds-input>

            @if (isApplicationReloadRequired) {
              <div class="account-profile-reload">
                <span>{{ 'application_restart_required' | translate }}</span>
                <button
                  ds-button
                  type="button"
                  [variant]="DsButtonVariants.microAction"
                  [hideMicroActionIcon]="true"
                  (click)="reloadApplication()"
                >
                  {{ 'reload_application' | translate }}
                </button>
              </div>
            }
          </div>

          @if (showVerticalNavigationOptin$ | async) {
            <hr />
            <div class="account-profile-vertical-nav-optin mb-4" data-test-id="account-profile-vertical-nav-optin">
              <ds-toggle
                [label]="'vertical_navigation_optin_settings_label' | translate"
                [checked]="(verticalNavigationOptinEnabled$ | async) === true"
                (valueChange)="onVerticalNavigationOptinChange($event)"
              />
              <p class="account-profile-vertical-nav-optin-text">
                {{ 'vertical_navigation_optin_settings_description' | translate }}
              </p>
              <p
                class="account-profile-vertical-nav-optin-text"
                [innerHTML]="'vertical_navigation_optin_settings_feedback' | translateHtml"
              ></p>
            </div>
          }

          @if (!modal) {
            <div class="mb-4">
              <app-user-mfa
                [mfaStatusResponse$]="mfaStatusResponse$"
                (enableMfa)="enableMfa()"
                (disableMfa)="disableMfa()"
              ></app-user-mfa>
            </div>
            <div class="row justify-content-sm-end mb-4">
              <div class="col-sm-auto">
                <button ds-button type="submit" [variant]="DsButtonVariants.primary">
                  {{ 'form_save_changes' | translate }}
                </button>
              </div>
            </div>
          }
        </fieldset>
      </form>
    </div>
  </div>
</div>
